import exceljs from "exceljs";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    MyDate, 
    mimeTypeMap, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Export({
    usersMap, 
    filteredBillings, 
}){
    const user = useMyStore(state => state.user);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const exportFunc = () => {
        setShowLoader(true);
        const workbook = new exceljs.Workbook();
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true;
        const worksheet = workbook.addWorksheet("My Sheet", {views: [{showGridLines: false}]});
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 22.57;
        const rows = filteredBillings.map(billing => [
            billing.billingNumber, 
            billing.projectName, 
            new Date(billing.startDate),
            new Date(billing.endDate),
            window.Number.parseFloat(billing.amount),
            billing.submitter,
            new Date(billing.submitTime?.replace(/-/g, "/")), 
            billing.updater, 
            billing.updateTime?new Date(billing.updateTime?.replace(/-/g, "/")):"", 
            `https://drive.google.com/uc?export=download&id=${billing.pdfId}`,
            billing.decision,
            billing.billed,
            billing.notes,
            usersMap[JSON.parse(billing.approval)[0].approverEmail], 
            JSON.parse(billing.approval)[0].approverDecision, 
            JSON.parse(billing.approval)[0].reviewTime?
            new Date(JSON.parse(billing.approval)[0].reviewTime?.replace(/-/g, "/")):"", 
            usersMap[JSON.parse(billing.approval)[1]?.approverEmail],
            JSON.parse(billing.approval)[1]?.approverDecision, 
            JSON.parse(billing.approval)[1]?.reviewTime?
            new Date(JSON.parse(billing.approval)[1]?.reviewTime?.replace(/-/g, "/")):"", 
            billing.void,
            billing.voidReason,
            billing.notify ?? ""
        ])
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            totalsRow: true,
            style: {
                showRowStripes: true,
            },
            columns: [
                { name: "Billing Number", filterButton: true},
                { name: "Project Name", filterButton: true},
                { name: "Start Date", filterButton: true},
                { name: "End Date", filterButton: true},
                { name: "Amount", filterButton: true, totalsRowFunction: "sum"},
                { name: "Submitter", filterButton: true},
                { name: "Submit Time", filterButton: true},
                { name: "Updater", filterButton: true},
                { name: "Update Time", filterButton: true},
                { name: "PDF", filterButton: true},
                { name: "Satus", filterButton: true},
                { name: "Billed", filterButton: true},
                { name: "Notes", filterButton: true},
                { name: "Approver 1 Name", filterButton: true},
                { name: "Approver 1 Decision", filterButton: true},
                { name: "Approver 1 Review Time", filterButton: true},
                { name: "Approver 2 Name", filterButton: true},
                { name: "Approver 2 Decision", filterButton: true},
                { name: "Approver 2 Review Time", filterButton: true},
                { name: "Void", filterButton: true},
                { name: "Void Reason", filterButton: true},
                { name: "Notify", filterButton: true}
            ],
            rows: rows,
        });
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), `billing export ${(new MyDate()).s()}.xlsx`);
            setShowLoader(false);
        })
    }
    return(
        <button type = "button" className = "headerButton" onClick = {exportFunc}>Export</button>
    )
}